import { API } from '@/api';
import { fetchFileNotes, fetchFileVersion } from '@/utils/files';

export const classes = {
  wrapper: 'px-0 py-0 flex flex-col',
  message: 'text-grey-7 dark:text-mauve-2 text-xl size-full place-center',
  viewer: 'grow flex justify-start',
};

export async function fetchFileData(fileId: number) {
  const [file, fileVersion, fileNotes] = await Promise.all([
    API.Files.fetchFile(fileId),
    fetchFileVersion(fileId),
    fetchFileNotes(fileId, { page: 1, pageSize: 100 }), // TODO: Pagination
  ]);
  return {
    file,
    fileVersion,
    fileNotes: fileNotes.results,
  };
}
